module.exports = __webpack_public_path__ + "img/bosconia490.448025fb.jpeg";